import React, { useState, useEffect } from "react";
import { Col, Card, CardBody, Form, Label, Row, Input } from "reactstrap";
import { Btn } from "../../../AbstractElements";
import { useForm } from "react-hook-form";
import { Save } from "../../../Constant";
import { routesApi, routesApiRole } from "../../../CommonUrl";
import { postClientUrlWithToken, putClientUrlWithToken } from "../../../Utils/restUtils";
import { toast } from "react-toastify";
import Transparentspinner from "../../Common/Loader/Transparentspinner";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import Popup from "../../Common/Popup/popup";
import { useSelector } from "react-redux";

const schema = yup.object().shape({
  name: yup.string().trim().required("Route name is required").label("Route Name"),

});

function AddEditRouteModal({ modal, handleModal, editData, refreshList }) {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      name: "",
      route_code: "",
      description: "",
      status: "active",
    },
  });
  const [loading, setLoading] = useState(false);
  const authState = useSelector((state) => state.auth);

  useEffect(() => {
    if (modal) {
      if (editData) {
        reset({
          name: editData.name || editData.route_name || "",
          route_code: editData.route_code || editData.code || "",
          description: editData.description || "",
          status: editData.status !== undefined && editData.status !== null
            ? (editData.status === 1 || editData.status === "1" || editData.status === "active" ? "active" : "inactive")
            : "active",
        });
      } else {
        reset({
          name: "",
          route_code: "",
          description: "",
          status: "active",
        });
      }
    }
  }, [editData, modal, reset]);

  const onSubmit = async (data) => {
    setLoading(true);
    const endpoint = authState?.userRole === 1 ? routesApi : routesApiRole;
    const cleanApiUrl = authState?.apiUrl || "";

    try {
      if (editData) {
        // Edit Mode (PUT)
        const routeId = editData.id || editData.route_id;
        const payload = {

          route_id: routeId,
          name: data.name,

        };

        // Try standard REST PUT /admin/routes/:id first, fallback to /admin/routes
        let result = await putClientUrlWithToken(cleanApiUrl, `${endpoint}/${routeId}`, payload);
        if (result?.status === 404 || result?.status === 405) {
          result = await putClientUrlWithToken(cleanApiUrl, endpoint, payload);
        }

        if (result?.status === 200 || result?.status === 201 || result?.data?.status === true) {
          toast.success(result?.data?.message || "Route updated successfully!");
          handleModal();
          reset();
          refreshList();
        } else {
          toast.error(result?.data?.message || "Failed to update route");
        }
      } else {
        // Add Mode (POST)
        const payload = {
          name: data.name,
        };

        const result = await postClientUrlWithToken(cleanApiUrl, endpoint, payload);
        if (result?.status === 200 || result?.status === 201 || result?.data?.status === true) {
          toast.success(result?.data?.message || "Route created successfully!");
          handleModal();
          reset();
          refreshList(result?.data?.data || payload);
        } else {
          toast.error(result?.data?.message || "Failed to create route");
        }
      }
    } catch (err) {
      console.error("Error saving route:", err);
      toast.error("An error occurred while saving route");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Popup
      title={editData ? "Edit Route" : "Add Route"}
      isOpen={modal}
      toggler={handleModal}
      size="md"
    >
      <>
        {loading && <Transparentspinner />}
        <Card className="border-0 shadow-none mb-0">
          <CardBody className="p-3">
            <Form className="needs-validation" noValidate onSubmit={handleSubmit(onSubmit)}>
              <Row className="g-3">
                <Col md="12">
                  <Label className="form-label fw-bold" htmlFor="route_name">
                    Route Name <span className="text-danger">*</span>
                  </Label>
                  <input
                    className="form-control"
                    id="route_name"
                    type="text"
                    placeholder="Enter route name"
                    {...register("name")}
                  />
                  {errors?.name && (
                    <span className="text-danger small mt-1 d-block">
                      {errors?.name?.message}
                    </span>
                  )}
                </Col>
              </Row>

              <div className="d-flex justify-content-end gap-2 mt-4">
                <Btn attrBtn={{ color: "light", type: "button", onClick: handleModal }}>
                  Cancel
                </Btn>
                <Btn attrBtn={{ color: "primary", type: "submit" }}>
                  {Save}
                </Btn>
              </div>
            </Form>
          </CardBody>
        </Card>
      </>
    </Popup>
  );
}

export default AddEditRouteModal;
